export default __webpack_public_path__ + "static/media/1_0022.73baf998.webp";